module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', [_c('table', {
    staticClass: "table-a"
  }, [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Projekt")]), _vm._v(" "), _c('th', [_vm._v("Kunde")]), _vm._v(" "), _c('th', [_vm._v("Betalingsmodel")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Til betaling")]), _vm._v(" "), _c('th', [_vm._v("Fakturering")]), _vm._v(" "), _c('th', [_vm._v("Aktiv")])]), _vm._v(" "), _vm._l((_vm.projects_money_owed), function(project, i) {
    return _c('tr', {
      key: 'asd' + i
    }, [_c('td', [_c('avatar', {
      attrs: {
        "input": project
      }
    })], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/project/' + project.key
      }
    }, [_vm._v(_vm._s(project.name))])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + project.client.key
      }
    }, [_vm._v(_vm._s(project.client.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tr_payment_model")(project.payment_model)))]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm._f("money")(project.payable_remaining, 0)) + " kr.")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("boolstr")(project.invoice_ready, ['Klar', 'Ikke klar'])))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("tr_project_status")(project.status)))])])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36e6417d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ReportMissingPayments.vue
// module id = 597
// module chunks = 1